/* @flow */
import React, { memo } from 'react';
import { Table } from 'antd';
import { TableProps } from 'antd/es/table';
import styles from './StandardTable.module.pcss';

interface Props extends TableProps {
  dataCy?: string;
}

const StandardTable = (props: Props) => {
  const { data, loading, pagination, rowKey, title, onChange, dataCy, ...rest } = props;

  return (
    <div className={styles.standardTable}>
      <Table
        {...rest}
        loading={loading}
        onChange={onChange}
        title={title}
        rowKey={rowKey}
        dataSource={data}
        pagination={pagination}
        data-cy={dataCy}
      />
    </div>
  );
};

const StandardTableMemo = memo<Props>(StandardTable);

export default StandardTableMemo;
